import { render, staticRenderFns } from "./edit-depot-name-form.vue?vue&type=template&id=0125846a&"
import script from "./edit-depot-name-form.vue?vue&type=script&lang=js&"
export * from "./edit-depot-name-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports